/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import {isDevelopment} from '../../libs/shared/helpers/src/environment/envHelpers';
import {FrontConfig} from '../../srcCommon/bundler/bundlerDefineConfig';

export function getLocalFeatureFlags() {
  if (!isDevelopment()) {
    return {};
  }

  const stagingNamespace = FrontConfig.STAGING_NAMESPACE;

  if (!stagingNamespace) {
    return {};
  }

  try {
    const json = require(`../../local_ff/${stagingNamespace}.json`);

    return json;
  } catch (e) {
    return {};
  }
}
